// extracted by mini-css-extract-plugin
export default {"root":"iB_1a"};